import { useMutation, useQuery } from 'react-query'
import API from '.'
import { serializeQuery } from './accounts'

const ENDPOINT = '/api/map-transactions'
const QUERY_KEY = 'map-transactions'

export const useGetMapTrans = (id, query, config = {}) =>
  useQuery(
    [QUERY_KEY, id, query],
    async () => (await API.get(serializeQuery(`${ENDPOINT}/${id}`, query))).data,
    config,
  )

export const useCreateMapTrans = (config = {}) =>
  useMutation((data) => API.post(ENDPOINT, data), config)

export const useUpdateMapTrans = (config = {}) =>
  useMutation((data) => API.patch(`${ENDPOINT}/${data.id}`, data), config)

export const useDeleteMapTrans = (config = {}) =>
  useMutation(({ id }) => API.delete(`${ENDPOINT}/${id}`), config)

export const useSyncMapTrans = (config = {}) =>
  useMutation((data) => API.post(`${ENDPOINT}/sync`, data), config)
